export default __webpack_public_path__ + "static/media/GoalTasksDemo.3533cac9.mp4";